<template>
  <div>
    <template>
      <div class="row mb-4 align-items-end justify-content-between">
        <div class="row col-lg-5">
          <h1 class="text-left mx-3">Unit Listings</h1>
          <b-button variant="vb-purple" @click="$emit('showUnitPreview', model_rowdata)">Floor Plans
            <font-awesome-icon :icon="['fas', 'wave-square']" /><font-awesome-icon
              :icon="['fas', 'caret-right']" /></b-button>
          <b-button variant="vb-tertiary" class="mx-2" v-if="
            ['Apartment', 'Mixed-Use Apartment'].some(
              (type) => projectType == type
            )
          " @click="goToStackingPlan()">Stacking Plan <font-awesome-icon :icon="['fas', 'layer-group']" /></b-button>
          <b-button variant="vb-tertiary" v-if="isAdmin" :disabled="selectedCids.length <= 0" @click="openBulkUpdateTab"
            class="ml-0">
            Bulk Update <font-awesome-icon :icon="['fas', 'cubes']" />
          </b-button>
        </div>
        <div class="col-lg-7 mt-4">
          <div class="d-flex col align-items-center justify-content-end mb-3">
            <div class="text-white p-2 mx-2 _price-backup" style="background-color: #0b36dc">
              Verified
            </div>
            <div class="text-white p-2 mx-2 _price-backup" style="background-color: #ff6f16">
              Semi-Verified
            </div>
            <div class="text-white bg-danger p-2 mx-2 _price-backup">
              Estimated
            </div>
          </div>
          <div class="d-flex" :class="{'justify-content-around' : isAdmin, 'float-right': !isAdmin}">
            <template v-for="(item, index, key) in totalListingSummary">
              <div class="">
                <h4 :key="index" class="p-2 mx-1 rounded text-light my-0" :class="{
                  'bg-success': [
                    'Confirmed Leased Units by Developer',
                    'Confirmed Sold Units by Developer',
                  ].includes(Object.keys(item)[0]),
                  'bg-dark': ![
                    'Confirmed Leased Units by Developer',
                    'Confirmed Sold Units by Developer',
                  ].includes(Object.keys(item)[0]),
                }" style="font-size: 22px;">
                  {{ Object.keys(item)[0] }}
                  <b-badge variant="light">{{ item[Object.keys(item)] }}
                  </b-badge>
                </h4>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <b-col class="align-items-lg-end col px-4">
          <div class="row">
            <div class="col pr-0">
              <treeselect class="border-vb-secondary mt-2 mb-0 pb-1 rounded custom_filter" id="project_status_filter"
                v-model="custom_filter.beds.beds_selected" :multiple="true" :options="custom_filter.beds.beds_options"
                value-consists-of="LEAF_PRIORITY" placeholder="Type" />
            </div>
            <div class="col pr-0">
              <FpSpecsFilter :selectedFpSpecs.sync="custom_filter.fpSpecs.fpSpecs_selected" />
            </div>
            <div class="col-2 pr-0">
              <treeselect class="border-vb-secondary mt-2 mb-0 pb-1 rounded custom_filter" id="custom_filter_plan_name"
                v-model="custom_filter.planName.planName_selected" :multiple="true" :load-options="loadOptions"
                :options="custom_filter.planName.planNameOptions" value-consists-of="LEAF_PRIORITY"
                placeholder="Plan Name" />
            </div>
            <div class="col-2 pr-0">
              <treeselect class="border-vb-secondary mt-2 mb-0 pb-1 rounded custom_filter" id="custom_filter_baths"
                v-model="custom_filter.baths.baths_selected" :multiple="true"
                :options="custom_filter.baths.baths_options" value-consists-of="LEAF_PRIORITY" placeholder="Baths" />
            </div>
            <div class="col">
              <RpdDoubleSlider :toggle-title="'Price'" :enable-range="enablePricedate" :range-value="rangeValue"
                v-on:switchRangeValue="switchRangeValue" :dateSelected.sync="custom_filter.priceDate.priceDate_selected"
                :isMarketRental="!isMarketStrata" />
            </div>
            <div class="col">
              <RpdDoubleSlider :toggle-title="'Sold'" :enable-range="enableSoldDate" :range-value="rangeValueSoldDate"
                v-on:switchRangeValue="switchRangeValue" :dateSelected.sync="custom_filter.soldDate.soldDate_selected"
                :isMarketRental="!isMarketStrata" />
            </div>
          </div>
          <div class="row justify-content-between align-items-center">
            <b-form-group>
              <div class="font-weight-bold">Status</div>
              <b-form-checkbox-group id="_status-buttons" size="sm" v-model="custom_filter.status.status_selected"
                :options="custom_filter.status.status_options" aria-describedby="status-buttons" name="status-buttons"
                buttons button-variant="outline-vb-tertiary"></b-form-checkbox-group>
            </b-form-group>
            <b-form-group>
              <div class="font-weight-bold">Listing Type</div>
              <b-form-checkbox-group id="_listing-type-buttons" class="switch-buttons" size="sm"
                v-model="custom_filter.listingType.listingType_selected"
                :options="custom_filter.listingType.listingType_options" aria-describedby="listing-type-buttons"
                name="listing-type-buttons" buttons button-variant="outline-vb-tertiary"></b-form-checkbox-group>
            </b-form-group>
            <b-form-group v-if="isAdmin">
              <div class="font-weight-bold">{{ isMarketStrata ? 'Sold' : 'Leased' }} Price Confidence</div>
              <b-form-checkbox-group id="_listing-type-buttons" class="switch-buttons" size="sm"
                v-model="custom_filter.priceConfidence.priceConfidence_selected"
                :options="custom_filter.priceConfidence.priceConfidence_options" aria-describedby="listing-type-buttons"
                name="listing-type-buttons" buttons button-variant="outline-vb-tertiary"></b-form-checkbox-group>
            </b-form-group>
            <div>
              <b-button v-b-modal.modal-filters variant="outline-vb-secondary" class="mx-2 mt-10">
                More Filters <font-awesome-icon :icon="['fas', 'filter']" />
              </b-button>
              <b-button size="sm" class="mr-2 mt-2 btn btn-outline-vb-primary rounded-pill" @click="saveFilters"
                v-if="listing_type != 'rental'">Save View | <font-awesome-icon :icon="['fas', 'archive']" /></b-button>

              <b-button v-if="!isAdmin" variant="outline-vb-red" class="mx-2 mt-10" @click="$emit('toggleField')">Fields
                <font-awesome-icon :icon="['fas', 'caret-square-down']" /></b-button>
            </div>
          </div>
          <div class="row justify-content-around">
            <div class="col-9">
              <span>Filters:</span>
              <span v-for="(filter, index) in rangeInputFilters">
                <b-badge class="mx-1" variant="vb-purple" v-if="filter.value.min || filter.value.max"
                  style="font-size: large">{{
                    filter.label }}:
                  {{ filter.value.min ? `min: ${filter.value.min}` : "" }}
                  <span v-if="filter.value.min && filter.value.max"> - </span>
                  {{ filter.value.max ? `max: ${filter.value.max}` : "" }}
                </b-badge>
              </span>
            </div>
            <div class="col-3 row justify-content-end">
              <b-button v-if="isAdmin" variant="outline-vb-red" class="mx-2 mt-10" @click="$emit('toggleField')">Fields
                <font-awesome-icon :icon="['fas', 'caret-square-down']" /></b-button>
            </div>
          </div>
        </b-col>
        <b-col :cols="isAdmin ? 5 : 6">
          <div class="justify-content-center align-items-center">
            <MlsAvailablePricing :is-market-strata="isMarketStrata" :row-data="model_rowdata" />
          </div>
        </b-col>
      </div>
      <div v-show="isAdmin && listing_type == 'all'" class="d-flex justify-content-end mb-3 align-items-end">
        <div v-if="showTabulator" class="col-lg-5 px-0">
          <label class="font-weight-bold small mb-1">Edit Specific Fields:</label>
          <treeselect class="custom_filter" v-model="bulkUpdateSelectedFields" :multiple="true"
            :options="staticBulkOptions" placeholder="Select fields to update" />
        </div>
        <b-button v-if="showTabulator && isAdmin" variant="success" class="mx-2" @click="saveAllDirtyRows"
          :disabled="!hasDirtyRows || isBusy">
          Save All Edited <font-awesome-icon :icon="['fas', 'save']" />
          <b-badge v-if="dirtyRowsCount > 0" variant="light" class="ml-1">{{ dirtyRowsCount }}</b-badge>
        </b-button>
      </div>
      <div class="row justify-content-end mb-3" v-if="isAdmin && listing_type == 'all'">
        <b-button-group size="sm" class="mr-3">
          <b-button :variant="showTabulator ? 'vb-primary' : 'outline-vb-primary'" @click="toggleView(true)">
            <font-awesome-icon :icon="['fas', 'table']" class="mr-1" /> Tabulator
          </b-button>
          <b-button :variant="!showTabulator ? 'vb-primary' : 'outline-vb-primary'" @click="toggleView(false)">
            <font-awesome-icon :icon="['fas', 'list']" class="mr-1" /> Default
          </b-button>
        </b-button-group>
      </div>
      <div v-if="showTabulator && listing_type == 'all' && isAdmin" ref="tabulatorTable" key="tabulator-view"></div>
      <!-- MlsDataTable (Bootstrap) -->
      <MlsDataTable v-else key="bootstrap-view" :items="model_rowdata" :header-fields="header_fields"
        :pre-sort.sync="pre_sort" :sort-compare="sortDate" :filter-function="filterProjectTable" :filter-on="filterOn"
        :filter-rows="filter_rows" :current-page="currentPage" :per-page="perPage" :row-class="rowClass"
        :listing-type="listing_type" :is-admin="isAdmin" :current-tab="currentTab" :current-user="current_user"
        :user-role="user_role" :open-tab="openTab" :show-flag="showFlag" :set-color="setColor"
        :set-confidence-color="setConfidenceColor" :is-in-current-quarter="isInCurrentQuarter" :isMarketStrata="isMarketStrata"
        :get-default-value="getDefaultValue" @filtered="onFiltered" @toggleFavorite="handleToggleFavorite"
        @refreshResults="handleRefresh" @popHistory="handlePopHistory" @selectAllRows="onSelectAllRows"
        @promptRow="promptRow" @deleteMLS="deleteMLS" @updateMls="updateMls" @deleteMlsRentalRow="deleteMlsRentalRow"  />
    </template>
    <RangeInputFilters v-model="rangeInputFilters" v-on:reset-filter="resetFilter" />
    <b-modal v-model="saveRowModalShow" title="Save Entry Type" @ok="confirmRowSave" ok-title="Confirm Save" centered>
      <p class="mb-3">Select all entry types that apply:</p>

      <b-form-group>
        <b-form-checkbox v-model="entryTypeSelection.isNewEntry" value="1" unchecked-value="0" class="mb-2">
          New Entry
        </b-form-checkbox>

        <b-form-checkbox v-model="entryTypeSelection.isOriginalEntry" value="1" unchecked-value="0">
          Original Entry
        </b-form-checkbox>
      </b-form-group>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
        <b-button size="sm" variant="success" @click="ok()">Confirm Save</b-button>
      </template>
    </b-modal>
    <b-modal id="pdf-modal" size="sm" title="Floor Plan Preview" hide-footer centered>
      <a v-if="selectedPdfUrl" :href="selectedPdfUrl.link" target="_blank">
        <img :src="selectedPdfUrl.preview" alt="Floor Plan Preview" style="width: 100%; height: auto;" />
      </a>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { VBModal, VBTooltip } from "bootstrap-vue";
import { useUserStore } from "../../store/UserStore";
import { BACKEND_URL, ROOT_URL } from "../../variables.js";
import { saveView, loadView } from "../../composables/asyncView.js";
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { wrapColumns } from "../../utilities/tabulatorSorter";
import { appendField } from "../../utilities/formData";
import axios from "axios";

// Components
import MlsAvailablePricing from "./MlsAvailablePricing.vue";
import RpdDoubleSlider from "./RpdDoubleSlider.vue";
import Treeselect from "@riophae/vue-treeselect";
import RangeInputFilters from "../common/RangeInputFilters.vue";
import FpSpecsFilter from "../../shared/components/FpSpecsFilter.vue";
import BulkUpload from "../Forms/BulkUpload.vue";
import CheckboxCell from '../tabulator_components/CheckboxCell.vue';
import UpdateMlsCell from "../tabulator_components/UpdateMlsCell.vue";
import FavoriteCell from "../tabulator_components/FavoriteCell.vue";
import HeaderUpdateBtn from "../tabulator_components/HeaderUpdateBtn.vue";
import BedsCell from "../tabulator_components/BedsCell.vue";
import SaveRowCell from "../tabulator_components/SaveRowCell.vue";
import AddressCell from "../tabulator_components/AddressCell.vue";
import FileUploadCell from "../tabulator_components/FileUploadCell.vue";
import DateCell from "../tabulator_components/DateCell.vue";

import MlsDataTable from "../RpdTables/MlsDataTable.vue";

// Constants/Styles
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';
import "@riophae/vue-treeselect/dist/vue-treeselect.css";


const sleep = d => new Promise(r => setTimeout(r, d));
const UpdateMlsCellComponent = Vue.extend(UpdateMlsCell);
const CheckboxCellComponent = Vue.extend(CheckboxCell);
const FavoriteCellComponent = Vue.extend(FavoriteCell);
const HeaderUpdateBtnComponent = Vue.extend(HeaderUpdateBtn);
const BedsCellComponent = Vue.extend(BedsCell);
const SaveRowCellComponent = Vue.extend(SaveRowCell);
const AddressCellComponent = Vue.extend(AddressCell);
const FileUploadCellComponent = Vue.extend(FileUploadCell);
const DateCellComponent = Vue.extend(DateCell);

export default {
  name: "MlsTableComponent",
  components: {
    MlsAvailablePricing,
    RpdDoubleSlider,
    Treeselect,
    RangeInputFilters,
    FpSpecsFilter,
    BulkUpload,
    MlsDataTable
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  props: {
    row_data: { type: Array, default: () => [] },
    header_fields: { type: Array, default: () => [] },
    perPage: { type: Number, default: null },
    currentPage: { type: Number, default: null },
    filter: { type: String, default: null },
    totalRows: { type: Number, default: null },
    listing_type: { type: String, default: null },
    user_role: { type: String, default: null },
    table_reference: { type: String, default: null },
    filterOn: { type: Array, default: () => [] },
    project_status: { type: String, default: null },
    filtered_data: { type: Array, default: () => [] },
    marketRentalPsfToDouble: { type: Number, default: null },
    filter_rows: { type: String, default: null },
    currentTab: { type: String, default: null },
    totalListingSummary: {
      type: [Object, Array],
      default: null
    },
    isMarketStrata: { type: Boolean, default: null },
    custom_headers: { type: Array, default: () => [] },
    queryParams: {
      type: [Object, String], // Change this from Object to [Object, String]
      default: null
    },
    projectType: { type: String, default: null },
    openTab: { type: String, default: null },
  },
  emits: [
    "popModal",
    "updateTotalRows",
    "selectAllRows",
    "popHistory",
    "countProjectSelected",
    "getFilteredData",
    "updateFields",
    "toggleField",
    "showUnitPreview",
    "toggleFavorite",
    "refreshResults",
    "deleteMLS",
    "updateMls",
    "deleteMlsRentalRow",
    "reloadData"
  ],
  data() {
    return {
      bulkUpdateSelectedFields: [],
      staticBulkOptions: [
        { id: 'mls_beds', label: 'Beds' },
        { id: 'mls_baths', label: 'Baths' },
        { id: 'mls_unit_size', label: 'Unit Size' },
        { id: 'mls_list_price', label: 'List Price' },
        { id: 'custom_sold_psf', label: 'PSF' },
        { id: 'mls_price_date', label: 'Price Date' },
        { id: 'buyer_incentives', label: 'Incentives' },
        { id: 'mls_sold_date', label: 'Sold Date' },
        { id: 'custom_status', label: 'Status' },
      ],
      selectedPdfUrl: null,
      isBulkSaving: false,
      showTabulator: this.isAdmin && this.listing_type == 'all',
      tabulatorInstance: null,
      multiSelectOptions: {
        fp_specs: ["Standard", "Luxury", "Modern", "Classic"],
        levels: ["1", "2", "3", "4+"],
        balcony: ["Yes", "No", "Juliet", "Terrace"],
        stalls: ["1", "2", "3", "Tandem"],
        mls_status: ["Active", "Sold", "Pending", "Expired", "Withdrawn"]
      },
      saveRowModalShow: false,
      rowToSave: null,
      selectedSaveEntryType: 'new entry',
      entryTypeSelection: {
        isAssignment: 0,
        isNewEntry: 0,
        isOriginalEntry: 0
      },
      table: null,
      // tabulator: null,
      selectedFpSpecs: [],
      isBusy: false,
      enablePricedate: false,
      enableSoldDate: false,
      filtered_mls_data: [],
      pre_sort: "",
      all_rows_selected: false,
      selectableTable: null,
      value: null,
      rangeInputFilters: {
        mls_unit_size: { label: "Unit Size", value: { min: null, max: null } },
        mls_list_price: { label: "List Price", value: { min: null, max: null } },
        mls_psf: { label: "PSF", value: { min: null, max: null } },
        net_psf: { label: "Net PSF", value: { min: null, max: null } },
        net_price: { label: "Net Price", value: { min: null, max: null } },
        mls_price_date: { type: "date", label: "Price Date", value: { min: null, max: null } },
        mls_sold_date: { type: "date", label: "Sold Date", value: { min: null, max: null } },
      },
      rangeValue: {
        min: 0,
        max: 0,
        minValue: 0,
        maxValue: 1000,
        startDate: null,
        endDate: null,
      },
      rangeValueSoldDate: {
        min: 0,
        max: 0,
        minValue: 0,
        maxValue: 1000,
        startDate: null,
        endDate: null,
      },
      custom_filter: {
        priceConfidence: { priceConfidence_selected: [], priceConfidence_options: [] },
        beds: {
          beds_selected: [],
          beds_options: [
            { id: "bed_Studio", label: "Studio" },
            { id: "bed_Jr 1-bed", label: "Jr 1-bed" },
            { id: "bed_1-bed", label: "1-bed" },
            { id: "bed_1-bed + Jr Bed", label: "1-bed + Jr Bed" },
            { id: "bed_2-bed", label: "2-bed" },
            { id: "bed_2-bed + Jr Bed", label: "2-bed + Jr Bed" },
            { id: "bed_3-bed", label: "3-bed" },
            { id: "bed_3-bed + Jr Bed", label: "3-bed + Jr Bed" },
            { id: "bed_4-bed", label: "4-bed" },
          ],
        },
        planName: { planName_selected: [], planNameOptions: [] },
        baths: {
          baths_selected: [],
          baths_options: [
            { id: "bath_1", label: "1" }, { id: "bath_1.5", label: "1.5" },
            { id: "bath_2", label: "2" }, { id: "bath_2.5", label: "2.5" },
            { id: "bath_3", label: "3" }, { id: "bath_3.5", label: "3.5" },
            { id: "bath_4", label: "4" }, { id: "bath_4.5", label: "4.5" },
            { id: "bath_5", label: "5" },
          ],
        },
        fpSpecs: {
          fpSpecs_selected: [],
          fpSpecs_options: [
            { id: "fp_Bonus Room", label: "Bonus Room" }, { id: "fp_Den", label: "Den" },
            { id: "fp_Den(2)", label: "Den(2)" }, { id: "fp_Furnished", label: "Furnished" },
            { id: "fp_Jr Bed(2)", label: "Jr Bed(2)" }, { id: "fp_Live/Work", label: "Live/Work" },
            { id: "fp_Lock-Off", label: "Lock-Off" }, { id: "fp_Loft", label: "Loft" },
            { id: "fp_None", label: "None" }, { id: "fp_PH", label: "PH" },
            { id: "fp_Roof Deck", label: "Roof Deck" }, { id: "fp_Sub-PH", label: "Sub-PH" },
            { id: "fp_TH", label: "TH" },
          ],
        },
        listingType: { listingType_selected: [], listingType_options: [] },
        priceDate: { priceDate_selected: "" },
        soldDate: { soldDate_selected: "" },
        status: { status_selected: [], status_options: [] },
      }
    };
  },
  watch: {
    tabulatorColumns: {
      handler(newColumns) {
        if (this.tabulator && this.tabulator.initialized) {
          this.$nextTick(() => {
            // This forces Tabulator to redraw with the new column subset
            this.tabulator.setColumns(newColumns);
          });
        }
      },
      deep: true
    },
    model_rowdata: {
      handler(newData) {
        if (this.tabulator && this.tabulator.initialized) {
          this.tabulator.replaceData(newData).catch(err => {
            console.warn("Tabulator data update suppressed", err);
          });
        }
      },
      deep: true
    },
  },
  computed: {
    allowedUsers() {
      return [
        "darcysrai@gmail.com",
        "erloucabilan94@gmail.com",
        "darcy@gmail.com",
      ].includes(this.current_user.mail);
    },
    dirtyRowsCount() {
      return this.model_rowdata.filter(row => row.isEdited).length;
    },
    hasDirtyRows() {
      return this.dirtyRowsCount > 0;
    },
    tabulatorColumns: {
      get: function () {
        const vm = this;
        let headers;
        if (this.bulkUpdateSelectedFields && this.bulkUpdateSelectedFields.length > 0) {
          headers = this.header_fields.filter(item =>
            this.bulkUpdateSelectedFields.includes(item.key) &&
            !["checkbox", "mls_address", "attachment"].includes(item.key)
          );
        } else {
          headers = this.header_fields.filter(item =>
            item.key !== "custom_price_change" &&
            item.key !== "mls_address" &&
            item.key !== "checkbox" &&   // Filter out checkbox from dynamic list
            item.key !== "attachment"    // Filter out attachment from dynamic list
          );
        }

        const headersWithActions = [
          { label: "Select All", key: "checkbox", width: 20 }, // Position 1: Checkbox
          { label: "Actions", key: "row_save_btn", width: 80 },  // Position 2: Save
          { label: "Address", key: "mls_address", width: 250 }, // Position 3: Address
          { label: "Attachment", key: "attachment", width: 80 }, // Position 4: File
          ...headers,
        ];
        const editableNumericFields = [
          "mls_beds", "mls_baths", "mls_unit_size", "parking",
          "mls_list_price", "mls_sold_price", "buyer_incentives", "realtor_incentives", "balcony_area", "mls_parking"
        ];

        const editableMultiSelectFields = [
          "fp_specs", "levels", "balcony", "stalls", "custom_status", "orientation", "price_back_up"
        ];

        const currencyFields = [
          "mls_list_price", "mls_sold_price", "list_price_net",
          "net_price", "buyer_incentives", "realtor_incentives",
          "custom_parking_stall_cost", "custom_storage_locker_cost"
        ];

        const psfFields = ["custom_mls_net_psf", "custom_sold_psf", "custom_net_psf", "mls_psf"];
        const dateFields = ["mls_price_date", "mls_sold_date", "price_date", "mls_list_date"];
        const priceBackupOptions = [
          { label: "Verified", value: "Verified" },
          { label: "Semi-Verified", value: "Semi-Verified" },
          { label: "Educated Estimated", value: "Educated Estimated" }
        ];
        const fpSpecsSource = [
          { "name": "Furnished", "value": "21170" },
          { "name": "None", "value": "11104" },
          { "name": "Den", "value": "10965" },
          { "name": "Jr Bed", "value": "10971" },
          { "name": "Sub-PH", "value": "10967" },
          { "name": "PH", "value": "10966" },
          { "name": "TH", "value": "10970" },
          { "name": "Roof Deck", "value": "10964" },
          { "name": "Bonus Room", "value": "11040" },
          { "name": "Den (2)", "value": "11132" },
          { "name": "Jr Bed (2)", "value": "21139" },
          { "name": "Live/Work", "value": "11039" },
          { "name": "Lock-Off", "value": "10968" },
          { "name": "Loft", "value": "11028" }
        ];
        const fpSpecsFormatted = fpSpecsSource.map(item => ({
          label: item.name,
          value: item.value
        }));

        const orientationSource = [
          { "text": "None", "value": 11105 },
          { "text": "East", "value": 11033 },
          { "text": "North", "value": 11030 },
          { "text": "North East", "value": 11035 },
          { "text": "North West", "value": 11034 },
          { "text": "South", "value": 11032 },
          { "text": "South East", "value": 11037 },
          { "text": "South West", "value": 11036 },
          { "text": "West", "value": 11031 }
        ];

        const orientationFormatted = orientationSource.map(item => ({
          label: item.text,
          value: item.value
        }));
        const stallsSource = [
          { "text": "None", "value": "11107" }, { "text": "Pad", "value": "21140" }, { "text": "Double", "value": "11110" },
          { "text": "Single", "value": "11108" }, { "text": "Tandem", "value": "11109" }, { "text": "Triple", "value": "21136" },
          { "text": "U/G", "value": "11111" }, { "text": "Null", "value": 0 }
        ];

        const stallsFormatted = stallsSource.map(item => ({
          label: item.text,
          value: item.value
        }));

        const levelsSource = [
          { "text": "None", "value": "11106" }, { "text": "1 Level", "value": "11074" }, { "text": "2 Level", "value": "11075" },
          { "text": "3 Level", "value": "11076" }, { "text": "4 Level", "value": "11077" }, { "text": "5 Level", "value": "11113" }
        ];

        const levelsFormatted = levelsSource.map(item => ({
          label: item.text,
          value: item.value
        }));
        const mlsStatusSource = [
          { "text": "None", "value": 11482 },
          { "text": "Active", "value": 8197 },
          { "text": "Sold", "value": 8198 },
          { "text": "Unreleased", "value": 23440 }
        ];

        const mlsStatusFormatted = mlsStatusSource.map(item => ({
          label: item.text || "None",
          value: item.value
        }));
        const multiSelectOptions = {
          levels: ["1", "2", "3", "4+"],
          balcony: ["Yes", "No"],
        };
        return headersWithActions.map(col => {
          let displayTitle = col.label;
          if ([...editableNumericFields, ...editableMultiSelectFields].includes(col.key)) {
            displayTitle += " *";
          }

          let columnConfig = {
            field: col.key,
            title: displayTitle,
            vertAlign: "middle",
            hozAlign: "left"
          };

          columnConfig.sorter = (a, b, aRow, bRow, column, dir, params) => {
            const aReal = this.isRealValue(a);
            const bReal = this.isRealValue(b);
            if (col.key === "custom_price_confidence") {
              const customOrder = {
                Verified: 1,
                Low: 2,
                Medium: 3,
                High: 4,
              };

              const valA = customOrder[a];
              const valB = customOrder[b];

              if (valA !== undefined && valB !== undefined) {
                return valA < valB ? -1 : (valA > valB ? 1 : 0);
              }

              if (dir === "desc") {
                if (valA === undefined && valB !== undefined) return -1;
                if (valB === undefined && valA !== undefined) return 1;
                return 0;
              } else {
                if (valA === undefined && valB !== undefined) return 1;
                if (valB === undefined && valA !== undefined) return -1;
                return 0;
              }
            }
            if (!aReal && !bReal) return 0;
            if (!aReal) return dir === "asc" ? 1 : -1;
            if (!bReal) return dir === "asc" ? -1 : 1;

            const parseCustomDate = (dateStr) => {
              if (!dateStr || typeof dateStr !== "string") return 0;
              const parts = dateStr.split("-");
              if (parts.length !== 3) return new Date(dateStr).getTime() || 0;
              const months = {
                Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
              };
              const day = parseInt(parts[0]);
              const month = months[parts[1]];
              const year = parseInt(parts[2]) < 100 ? 2000 + parseInt(parts[2]) : parseInt(parts[2]);
              return new Date(year, month, day).getTime();
            };

            const isDateField = column.getField().toLowerCase().includes("date");
            const dateRegex = /^\d{1,2}-[A-Za-z]{3}-\d{2}$/;

            if (isDateField || (dateRegex.test(a) && dateRegex.test(b))) {
              return parseCustomDate(a) - parseCustomDate(b);
            }

            const isNumeric = (val) => !isNaN(val) && !isNaN(parseFloat(val));
            if (isNumeric(a) && isNumeric(b)) {
              return parseFloat(a) - parseFloat(b);
            }

            const strA = (a || "").toString().toLowerCase();
            const strB = (b || "").toString().toLowerCase();
            return strA.localeCompare(strB);
          };

          const mountVueComponent = (cell, Component, props) => {
            const data = cell.getData();
            if (!data || Object.keys(data).length === 0) return "";
            const container = document.createElement("div");
            const componentInstance = new Component({
              propsData: props
            });
            componentInstance.$mount(container);
            cell.getTable().on("cellDestroyed", (deletedCell) => {
              if (deletedCell === cell) {
                componentInstance.$destroy();
              }
            });
            return componentInstance.$el;
          };

          if (col.key === "row_save_btn") {
            columnConfig.frozen = true;
            columnConfig.width = 80;
            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              if (!data.isEdited) return "";
              const container = document.createElement("div");
              const componentInstance = new SaveRowCellComponent({
                propsData: { row: data }
              });
              componentInstance.$mount(container);
              componentInstance.$on('save', (rowData) => {
                this.handleRowSave(rowData);
              });
              return componentInstance.$el;
            };
          }
          if (editableMultiSelectFields.includes(col.key)) {
            let listValues = [];
            if (col.key === 'fp_specs') {
              listValues = fpSpecsFormatted;
            } else if (col.key === 'orientation') {
              listValues = orientationFormatted;
            } else if (col.key === 'stalls') {
              listValues = stallsFormatted;
            } else if (col.key === 'levels') {
              listValues = levelsFormatted;
            } else if (col.key === 'custom_status') {
              listValues = mlsStatusFormatted;
            } else if (col.key === 'price_back_up') {
              listValues = priceBackupOptions;
            } else {
              listValues = multiSelectOptions[col.key] || [];
            }

            columnConfig.editor = "list";
            columnConfig.editorParams = {
              values: listValues,
              multiselect: col.key == 'fp_specs' ? true : false,
              autocomplete: false,
              allowEmpty: true,
              listOnEmpty: true,
              verticalNavigation: "editor",
            };

            columnConfig.formatter = (cell) => {
              const val = cell.getValue();
              const element = cell.getElement();
              if (!this.isRealValue(val)) return "-";

              const selectedArray = Array.isArray(val)
                ? val
                : val.toString().split(",").map(i => i.trim());

              // 1. Generate the Text Label(s)
              const labels = selectedArray.map(v => {
                let match;
                switch (col.key) {
                  case 'custom_status':
                    match = mlsStatusSource.find(opt => opt.value == v || opt.text == v);
                    return match ? (match.text || "None") : v;
                  case 'levels':
                    match = levelsSource.find(opt => opt.value == v || opt.text == v);
                    return match ? match.text : v;
                  case 'stalls':
                    match = stallsSource.find(opt => opt.value == v || opt.text == v);
                    return match ? match.text : v;
                  case 'orientation':
                    match = orientationSource.find(opt => opt.value == v || opt.text == v);
                    return match ? match.text : v;
                  case 'fp_specs':
                    match = fpSpecsSource.find(opt => opt.value == v || opt.name == v);
                    return match ? match.name : v;
                  default:
                    return v;
                }
              });

              const displayText = labels.join(", ");

              if (col.key === 'custom_status') {
                const lowerText = displayText.toLowerCase();
                element.style.fontWeight = "bold";

                if (lowerText.includes("active")) {
                  element.style.color = "#28a745";
                } else if (['sold', 'leased'].some(status => lowerText === status)) {
                  element.style.color = "#dc3545";
                } else if (lowerText.includes("unreleased")) {
                  element.style.color = "#000";
                } else {
                  element.style.color = "#000";
                }
              }

              return displayText;
            };

            columnConfig.cellEdited = (cell) => {
              const rowData = cell.getData();
              if (Array.isArray(rowData[col.key])) {
                rowData[col.key] = rowData[col.key].join(", ");
              }
              rowData.isEdited = true;
              this.syncDataChange(rowData);
              cell.getRow().update({ isEdited: true });
            };
          }
          if (dateFields.includes(col.key)) {
            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              if (!data || Object.keys(data).length === 0) return "";

              const container = document.createElement("div");
              const componentInstance = new DateCellComponent({
                propsData: {
                  row: data,
                  field: col.key,
                  isAdmin: this.isAdmin,
                  // Only the Leased / Sold Date column offers a clear button.
                  // It is the one date here that can turn out not to belong to a
                  // unit at all — a sale or lease entered against the wrong row,
                  // or one that fell through — where the other three describe a
                  // listing that does exist and are corrected rather than
                  // removed. `mls_sold_date` is the field behind both labels
                  // ("Leased Date" on rental, "Sold Date" on strata).
                  clearable: col.key === "mls_sold_date",
                  label: col.label
                }
              });

              // Listen for the update event
              componentInstance.$on('date-updated', (payload) => {
                // Sync with your Vue data state
                this.syncDataChange(payload.row);
                // Update Tabulator row visually
                cell.getRow().update({ isEdited: true });
              });

              componentInstance.$mount(container);

              // Clean up when cell is destroyed
              cell.getTable().on("cellDestroyed", (deletedCell) => {
                if (deletedCell === cell) {
                  componentInstance.$destroy();
                }
              });

              return componentInstance.$el;
            };
          }
          if (col.key === "attachment") {
            columnConfig.title = "File";
            columnConfig.width = 100;
            columnConfig.hozAlign = "center";
            columnConfig.formatter = (cell) => {
              const container = document.createElement("div");
              const componentInstance = new FileUploadCellComponent({
                propsData: { row: cell.getData(), queryParams: this.$route.query }
              });

              componentInstance.$on('upload-success', (payload) => {
                const row = cell.getRow();
                row.update({
                  mls_attachment_url: payload.newUrl,
                  isEdited: true
                });
                this.syncDataChange(row.getData());
              });

              componentInstance.$on('file-selected', (fileObject) => {
                const row = cell.getRow();
                row.update({
                  pending_file: fileObject,
                  isEdited: true
                });
                this.syncDataChange(row.getData());
              });

              componentInstance.$mount(container);
              return componentInstance.$el;
            };
          }

          else if (psfFields.includes(col.key)) {
            columnConfig.hozAlign = "left";
            columnConfig.formatter = (cell) => {
              const value = cell.getValue();
              const precision = this.isMarketStrata ? 0 : 2;
              return this.applyNumericFormat(value, true, precision);
            };
          }

          else if (currencyFields.includes(col.key)) {
            columnConfig.hozAlign = "left";
            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              const value = cell.getValue();

              if (col.key === "mls_list_price") {
                const element = cell.getElement();
                const status = data.price_back_up || "";
                element.style.color = this.setColor(status);
                element.style.fontWeight = "bold";
              }

              return this.applyNumericFormat(value, true, 0);
            };
          }

          else if (col.key === "checkbox") {
            columnConfig.frozen = true
            columnConfig.formatter = (cell) => mountVueComponent(cell, CheckboxCellComponent, {
              row: cell.getData(),
              listingType: this.listing_type,
              onPromptRow: (rowData) => this.promptRow(rowData),
              onDeleteRow: (payload) => this.$emit('deleteMlsRentalRow', payload)
            });
            columnConfig.titleFormatter = (column) => {
              const container = document.createElement("div");
              container.style.display = "flex";
              container.style.justifyContent = "center";
              container.textContent = "Select All";
              const checkbox = document.createElement("input");
              checkbox.type = "checkbox";
              checkbox.style.cursor = "pointer";
              checkbox.style.marginLeft = "5px";
              checkbox.style.width = "16px";
              checkbox.style.height = "16px";
              checkbox.addEventListener("change", (e) => {
                const isChecked = e.target.checked;
                const table = column.getTable();
                const rows = table.getRows();

                rows.forEach(row => {
                  // Update the row data in Tabulator
                  // This triggers a re-render of the cell formatter (your Vue component)
                  row.update({ rowSelected: isChecked });

                  // Sync the change back to your Vue data state
                  const updatedData = row.getData();
                  this.syncDataChange(updatedData);
                });
              });

              container.appendChild(checkbox);
              return container;
            };
          }

          else if (col.key === "updatemls") {
            columnConfig.formatter = (cell) => mountVueComponent(cell, UpdateMlsCellComponent, {
              row: cell.getData(),
              openTab: this.openTab,
              showFlag: this.showFlag,
              isAdmin: this.isAdmin,
              isMarketStrata: this.isMarketStrata,
              onUpdateMls: (payload) => this.$emit('updateMls', payload)
            });
          }

          else if (col.key === "favorite") {
            columnConfig.hozAlign = "center";
            columnConfig.width = 50;
            columnConfig.formatter = (cell) => mountVueComponent(cell, FavoriteCellComponent, {
              row: cell.getData(),
              isFavorite: cell.getValue(),
              onToggleFavorite: (rowData) => this.$emit('toggleFavorite', rowData)
            });
          }

          if (col.key === "mls_address") {
            columnConfig.width = 250;
            columnConfig.frozen = true;

            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              if (!data || Object.keys(data).length === 0) return "";

              const container = document.createElement("div");
              const componentInstance = new AddressCellComponent({
                propsData: { row: data }
              });

              componentInstance.$on('view-history', (rowData) => {
                this.handleOpenHistory(rowData);
              });

              componentInstance.$on('preview-pdf', (url) => {
                this.openPdfPreview(url);
              });

              componentInstance.$mount(container);

              cell.getTable().on("cellDestroyed", (deletedCell) => {
                if (deletedCell === cell) {
                  componentInstance.$destroy();
                }
              });

              return componentInstance.$el;
            };
          }

          else if (col.key === "custom_field_mls_beds_value") {
            columnConfig.width = 130;
            columnConfig.accessorSort = (value, data) => data.custom_field_mls_beds_value?.type;
            columnConfig.formatter = (cell) => mountVueComponent(cell, BedsCellComponent, {
              row: cell.getData(),
              bedsData: cell.getData().custom_field_mls_beds_value,
              userRole: this.current_user.role,
              listingType: this.listing_type
            });
          }

          if (col.key === "custom_listing_type") {
            columnConfig.formatter = (cell) => {
              const val = (cell.getValue() || "").toLowerCase();
              let bgColor = "#6c757d";
              let textColor = "#ffffff";

              if (["re-lease", "resale"].includes(val.toLowerCase())) {
                bgColor = "#fc5868";
              } else if (["new lease", "presale"].includes(val)) {
                bgColor = "#426586";
              } else if (val === "assignment") {
                bgColor = "#ffc107";
                textColor = "#000000";
              }

              if (!val) return "-";

              return `<span style="
                display: inline-block;
                padding: 2px 8px;
                border-radius: 12px;
                font-size: 15px;
                font-weight: bold;
                text-transform: uppercase;
                background-color: ${bgColor};
                color: ${textColor};
              ">${val}</span>`;
            };
          }
          if (col.key === "custom_price_confidence") {
            columnConfig.formatter = (cell) => {
              const value = cell.getValue();
              const element = cell.getElement();
              element.style.fontWeight = "bold";

              if (value === "High") element.style.color = "#28a745";      // Green
              else if (value === "Medium") element.style.color = "#ffc107"; // Yellow/Gold
              else if (value === "Low") element.style.color = "#dc3545";    // Red

              return value || "-";
            };
          }
          if (editableNumericFields.includes(col.key)) {
            columnConfig.editor = "number";
            columnConfig.cellEdited = (cell) => {
              const row = cell.getRow();
              const rowData = cell.getData();
              rowData.isEdited = true;
              this.syncDataChange(rowData);
              row.update({ isEdited: true });
            };

            if (!columnConfig.formatter) {
              columnConfig.formatter = (cell) => this.applyNumericFormat(cell.getValue(), false, 0);
            }
          }

          return columnConfig;
        });
      },
      set: function (newVal) { return newVal; }
    },
    current_user() {
      return useUserStore().current_user;
    },
    isAdmin() {
      return this.current_user && this.current_user.role === "admin";
    },
    showFlag() {
      return [
        "mark.wang+urban@devradius.com",
        "Erl@devbc.com",
        "markdeveloperbc@test.com",
        "darcysrai@gmail.com",
        "darcy@gmail.com",
      ].includes(this.current_user?.mail);
    },
    maxDateValue() {
      if (!this.row_data) return 0;

      const filtered = this.row_data.filter((data) => data.mls_price_date && data.mls_price_date !== "-");

      let maxDays = filtered.reduce((max, item) => {
        let diffDays = this.getDiffDays(item.mls_price_date);
        return diffDays > max ? diffDays : max;
      }, 0);

      const priceDates = filtered.map((item) => new Date(item.mls_price_date));
      if (priceDates.length > 0) {
        this.rangeValue.startDate = new Date(Math.min(...priceDates));
      }

      this.rangeValue.max = maxDays;

      return maxDays;
    },

    maxSoldDateValue() {
      if (!this.row_data) return 1000;

      const filtered = this.row_data.filter((data) => data.mls_sold_date && data.mls_sold_date !== "-");
      // Calculate max days
      let maxDays = filtered.reduce((max, item) => {
        let diffDays = this.getDiffDays(item.mls_sold_date);
        return diffDays > max ? diffDays : max;
      }, 0);

      // Calculate start date
      const soldDates = filtered.map((item) => new Date(item.mls_sold_date));
      if (soldDates.length > 0) {
        this.rangeValueSoldDate.startDate = new Date(Math.min(...soldDates));
      }

      // Sync the max value to the range object
      const result = maxDays > 0 && maxDays ? maxDays : 1000;
      this.rangeValueSoldDate.max = result;

      return result;
    },
    model_rowdata() {
      var filtered_data = this.row_data;
      var priceConfidenceSelected = this.custom_filter.priceConfidence["priceConfidence_selected"] || [];

      const isFilterActive = [
        this.custom_filter.beds.beds_selected,
        this.custom_filter.fpSpecs.fpSpecs_selected,
        this.custom_filter.baths.baths_selected,
        this.custom_filter.priceDate.priceDate_selected,
        this.custom_filter.soldDate.soldDate_selected,
        this.custom_filter.status.status_selected,
        this.custom_filter.planName.planName_selected,
        this.custom_filter.listingType["listingType_selected"],
        priceConfidenceSelected
      ].some((x) => x.length > 0) || this.enablePricedate || this.enableSoldDate;

      if (isFilterActive) {
        let type = [], fp = [], bath = [], plan = [];

        // Bed Filter
        if (this.custom_filter.beds.beds_selected.length > 0) {
          this.custom_filter.beds.beds_selected.forEach(val => {
            if (val.startsWith("bed_")) type.push(val.replace("bed_", ""));
          });
          filtered_data = filtered_data.filter(item =>
            type.some(t => {
              if (t === item.custom_field_mls_beds_value.type && item.custom_field_mls_beds_value.fp_specs != "Jr Bed") return true;
              if (item.custom_field_mls_beds_value.fp_specs == "Jr Bed") {
                return t.search(item.custom_field_mls_beds_value.type) > -1 && t.search(item.custom_field_mls_beds_value.fp_specs) > -1;
              }
            })
          );
        }

        // FP Specs Filter
        if (this.custom_filter.fpSpecs.fpSpecs_selected.length > 0) {
          filtered_data = filtered_data.filter(item => {
            let split = item.fp_specs.split(",").map(s => s.trim());
            return this.custom_filter.fpSpecs.fpSpecs_selected.some(spec => split.includes(spec));
          });
        }

        // Bath Filter
        if (this.custom_filter.baths.baths_selected.length > 0) {
          bath = this.custom_filter.baths.baths_selected.map(v => v.replace("bath_", ""));
          filtered_data = filtered_data.filter(item => bath.includes(item.mls_baths));
        }

        // Listing Type
        if (this.custom_filter.listingType.listingType_selected.length > 0) {
          filtered_data = filtered_data.filter(item => this.custom_filter.listingType.listingType_selected.includes(item.custom_listing_type));
        }

        // Price Confidence
        if (this.custom_filter.priceConfidence.priceConfidence_selected.length > 0) {
          filtered_data = filtered_data.filter(item => this.custom_filter.priceConfidence.priceConfidence_selected.includes(item.custom_price_confidence));
        }

        // Plan Name
        if (this.custom_filter.planName.planName_selected.length > 0) {
          plan = this.custom_filter.planName.planName_selected.map(v => v.replace("plan_", ""));
          filtered_data = filtered_data.filter(item => plan.includes(item.mls_plan_name));
        }

        // Status
        if (this.custom_filter.status.status_selected.length > 0) {
          filtered_data = filtered_data.filter(item => {
            const val = this.listing_type && this.isMarketStrata ? item.mls_status : item.custom_status;
            return this.custom_filter.status.status_selected.includes(val);
          });
        }

        // Date Logic
        const toUTCMidnight = (dateInput) => {
          const date = new Date(dateInput);
          if (isNaN(date.getTime())) return null;
          date.setUTCHours(0, 0, 0, 0);
          return date;
        };

        if (this.isAdmin && this.$route.path != "/type") {
          if (this.enablePricedate) {
            filtered_data = filtered_data.filter(item =>
              item.mls_price_date != "-" &&
              toUTCMidnight(item.mls_price_date) >= toUTCMidnight(this.rangeValue.startDate) &&
              toUTCMidnight(item.mls_price_date) <= toUTCMidnight(this.rangeValue.endDate)
            );
          }
          if (this.enableSoldDate) {
            filtered_data = filtered_data.filter(item =>
              item.mls_price_date != "-" &&
              toUTCMidnight(item.mls_price_date) >= toUTCMidnight(this.rangeValueSoldDate.startDate) &&
              toUTCMidnight(item.mls_price_date) <= toUTCMidnight(this.rangeValueSoldDate.endDate)
            );
          }
        } else {
          if (this.enablePricedate && this.custom_filter.priceDate.priceDate_selected) {
            filtered_data = filtered_data.filter(item => item.mls_price_date != "-" && this.getDiffDays(item.mls_price_date) <= this.custom_filter.priceDate.priceDate_selected);
          }
          if (this.enableSoldDate && this.custom_filter.soldDate.soldDate_selected) {
            filtered_data = filtered_data.filter(item => item.mls_sold_date != "-" && this.getDiffDays(item.mls_sold_date) <= this.custom_filter.soldDate.soldDate_selected);
          }
        }
      }

      // Range Input Filters
      for (const filterKey in this.rangeInputFilters) {
        const filter = this.rangeInputFilters[filterKey];
        const { min, max } = filter.value;
        if (this.isRealValue(min) || this.isRealValue(max)) {
          filtered_data = filtered_data.filter(item => {
            const itemValue = item[filterKey];
            if (!this.isRealValue(itemValue)) return false;
            let passMin = this.isRealValue(min) ? (filter.type === "date" ? new Date(itemValue) >= new Date(min) : Math.round(itemValue) >= min) : true;
            let passMax = this.isRealValue(max) ? (filter.type === "date" ? new Date(itemValue) <= new Date(max) : Math.round(itemValue) <= max) : true;
            return passMin && passMax;
          });
        }
      }

      this.$emit("updateTotalRows", { filtered_data, listingType: this.listing_type });
      return filtered_data;
    },
    selectedCids() {
      return this.model_rowdata.filter(item => item.rowSelected).map(item => {
        return {
          cid: item.cid,
          unit_number: item.mls_address
        }
      });
    },
    model_totalrows: {
      get() { return this.totalRows; },
      set(newVal) { this.$emit("updateTotalRows", newVal); }
    },
    getViewCategory() {
      const mapping = {
        "In Planning": 32, "Now Selling": 33, "Now Selling 2": 34, "Selling Soon": 35,
        "Sold Out": 36, "Sold Out 2": 37, "Leasing Soon": 38, "Now Leasing": 39,
        "Now Leasing 2": 40, "Leased Out": 41, "Leased Out 2": 42
      };
      return mapping[this.project_status] || 43;
    }
  },
  methods: {
    openBulkUpdateTab() {
      this.$emit('triggerBulkUpdate', this.selectedCids);
    },
    openPdfPreview(url) {
      this.selectedPdfUrl = url;
      this.$bvModal.show('pdf-modal');
    },
    prepareFormData(rowData, entryTypes) {
      const fpSpecsSource = [
        { "name": "Furnished", "value": "21170" },
        { "name": "None", "value": "11104" },
        { "name": "Den", "value": "10965" },
        { "name": "Jr Bed", "value": "10971" },
        { "name": "Sub-PH", "value": "10967" },
        { "name": "PH", "value": "10966" },
        { "name": "TH", "value": "10970" },
        { "name": "Roof Deck", "value": "10964" },
        { "name": "Bonus Room", "value": "11040" },
        { "name": "Den (2)", "value": "11132" },
        { "name": "Jr Bed (2)", "value": "21139" },
        { "name": "Live/Work", "value": "11039" },
        { "name": "Lock-Off", "value": "10968" },
        { "name": "Loft", "value": "11028" }
      ];

      const orientationSource = [
        { "text": "None", "value": 11105 },
        { "text": "E", "value": 11033 },
        { "text": "N", "value": 11030 },
        { "text": "NE", "value": 11035 },
        { "text": "NW", "value": 11034 },
        { "text": "S", "value": 11032 },
        { "text": "SE", "value": 11037 },
        { "text": "SW", "value": 11036 },
        { "text": "W", "value": 11031 }
      ];

      const stallsSource = [
        { "text": "None", "value": "11107" },
        { "text": "Pad", "value": "21140" },
        { "text": "Double", "value": "11110" },
        { "text": "Single", "value": "11108" },
        { "text": "Tandem", "value": "11109" },
        { "text": "Triple", "value": "21136" },
        { "text": "U/G", "value": "11111" },
        { "text": "Null", "value": 0 }
      ];

      const levelsSource = [
        { "text": "None", "value": "11106" },
        { "text": "1 Level", "value": "11074" },
        { "text": "2 Level", "value": "11075" },
        { "text": "3 Level", "value": "11076" },
        { "text": "4 Level", "value": "11077" },
        { "text": "5 Level", "value": "11113" }
      ];

      const mlsStatusSource = [
        { "text": "None", "value": 11482 },
        { "text": "Active", "value": 8197 },
        { "text": "Sold", "value": 8198 },
        { "text": "Leased", "value": 8198 },
        { "text": "Unreleased", "value": 23440 }
      ];

      const getMappedValues = (input, sourceArr, matchKey) => {
        if (input === null || input === undefined || input === "-") return "";
        const inputStr = String(input).trim();
        if (!inputStr) return "";

        return inputStr.split(',')
          .map(item => item.trim())
          .map(item => {
            // Look for match in 'text'/'name' or 'value'
            const match = sourceArr.find(s =>
              String(s[matchKey]) === item || String(s.value) === item
            );
            return match ? match.value : item;
          })
          .join(',');
      };

      const parseCustomToISO = (customStr) => {
        if (!customStr || customStr === "-") return "";
        const parts = customStr.split("-");
        if (parts.length !== 3) return customStr;

        const day = parts[0];
        const monthStr = parts[1];
        const yearShort = parts[2];

        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthIndex = monthNames.indexOf(monthStr);
        const month = String(monthIndex + 1).padStart(2, '0');

        const year = parseInt(yearShort) < 70 ? `20${yearShort}` : `19${yearShort}`;

        return `${year}-${month}-${day}`;
      };

      const formData = new FormData();

      formData.append('status', getMappedValues(rowData.custom_status, mlsStatusSource, "text") || 11482);
      formData.append('fp', getMappedValues(rowData.fp_specs, fpSpecsSource, "name"));
      formData.append('orientation', getMappedValues(rowData.orientation, orientationSource, "text"));
      formData.append('pr', getMappedValues(rowData.stalls, stallsSource, "text"));
      formData.append('fl', getMappedValues(rowData.levels, levelsSource, "text"));

      formData.append('bath', rowData.mls_baths || '');
      formData.append('listPrice', rowData.mls_list_price || 0);
      formData.append('soldPrice', rowData.mls_sold_price || 0);
      formData.append('unitSize', rowData.mls_unit_size || 0);
      formData.append('balconyArea', rowData.balcony_area || 0);
      formData.append('unit', rowData.mls_address || '');
      formData.append('balcony', rowData.balcony || '');
      formData.append("buyerIncentives", rowData.buyer_incentives || 0);
      formData.append('assignment', entryTypes.isAssignment || 0);
      formData.append('newEntry', entryTypes.isNewEntry || 0);
      formData.append('originalEntry', entryTypes.isOriginalEntry || 0);

      // if (rowData.pending_file) {
      //   formData.append('backupfile', rowData.pending_file);
      // }
      appendField(formData, 'backupfile', rowData.pending_file);
      // Context IDs from URL
      formData.append('uid', this.$route.query.uid || '');
      formData.append('fid', this.$route.query.fid || '');
      formData.append('owner', this.$route.query.owner || '');
      formData.append('purchaser', this.$route.query.purchaser || '');
      // Formatted Dates
      formData.append("soldDate", parseCustomToISO(rowData.mls_sold_date));
      formData.append("listDate", parseCustomToISO(rowData.mls_list_date));
      formData.append("listPriceDate", parseCustomToISO(rowData.mls_price_date));
      formData.append("priceBackup", rowData.price_back_up || '');
      formData.append("realtorIncentives", rowData.realtor_incentives || 0);
      formData.append("bed", rowData.mls_beds || 0);

      return formData;
    },
    saveAllDirtyRows() {
      const dirtyRows = this.model_rowdata.filter(row => row.isEdited);
      if (dirtyRows.length === 0) return;

      this.isBulkSaving = true;
      this.rowToSave = null;

      this.entryTypeSelection = {
        isAssignment: 0,
        isNewEntry: 0,
        isOriginalEntry: 0
      };

      this.saveRowModalShow = true;
    },
    async confirmRowSave() {
      this.isBusy = true;
      try {
        const rowsToProcess = this.isBulkSaving
          ? this.model_rowdata.filter(row => row.isEdited)
          : [this.rowToSave];
        for (const row of rowsToProcess) {
          const formData = this.prepareFormData(row, this.entryTypeSelection);
          await axios.post(BACKEND_URL + 'api/presale_mls_creation', formData);

          row.isEdited = false;
          row.pending_file = null;
          this.syncDataChange(row);

          if (this.tabulator) {
            const tabRow = this.tabulator.getRow(row.cid);
            if (tabRow) tabRow.update({ isEdited: false, pending_file: null });
          }
        }

        this.$emit('reloadData');
        this.$bvToast.toast(
          this.isBulkSaving ? "All edited rows saved successfully" : "Listing updated successfully",
          { variant: "success" }
        );

        this.saveRowModalShow = false;
      } catch (error) {
        console.error("Submission error:", error);
        this.$bvToast.toast("Failed to save data", { variant: "danger" });
      } finally {
        this.isBusy = false;
        this.isBulkSaving = false;
      }
    },
    handleToggleFavorite(rowData) {
      this.$emit('toggleFavorite', rowData);
    },
    handleRefresh(type) {
      this.$emit('refreshResults', type);
    },
    handlePopHistory(rowData) {
      this.$emit('popHistory', rowData);
    },
    deleteMLS(payload) {
      this.$emit('deleteMLS', payload);
    },
    updateMls(payload) {
      this.$emit('updateMls', payload);
    },
    deleteMlsRentalRow(payload) {
      this.$emit('deleteMlsRentalRow', payload);
    },
    toggleView(isTabulator) {
      this.showTabulator = isTabulator;
      if (isTabulator) {
        this.$nextTick(() => {
          this.initializeTabulator();
        });
      }
    },
    handleOpenHistory(rowData) {
      this.$emit('popHistory', rowData);
    },
    applyNumericFormat(value, isCurrency, precision = 0) {
      if (!this.isRealValue(value)) return "-";

      if (isCurrency) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: precision,
          maximumFractionDigits: precision,
        }).format(value);
      }
      return value;
    },
    handleRowSave(rowData) {
      this.isBulkSaving = false;
      this.rowToSave = rowData;

      this.entryTypeSelection = {
        isAssignment: 0,
        isNewEntry: 0,
        isOriginalEntry: 0
      };

      this.saveRowModalShow = true;
    },
    syncDataChange(updatedRow) {
      const index = this.row_data.findIndex(item => item.cid === updatedRow.cid);
      if (index !== -1) {
        this.$set(this.row_data, index, { ...updatedRow });
      }
    },
    resetFilter() {
      for (let filter in this.rangeInputFilters) {
        this.rangeInputFilters[filter].value = { min: null, max: null };
      }
    },
    switchRangeValue(value) {
      if (value === "Price") this.enablePricedate = !this.enablePricedate;
      else if (value === "Sold") this.enableSoldDate = !this.enableSoldDate;
    },
    goToStackingPlan() {
      const { href } = this.$router.resolve({
        name: "stackingplan",
        params: { urlParams: this.queryParams },
      });
      window.open(href, "_blank");
    },
    isRealValue(value) {
      return !["zero", "", "-", null, 0, undefined, "null", "$0", "0", " ", "0.00", 0.00, "$0.00"].includes(value);
    },
    getDiffDays(date) {
      let date1 = new Date();

      let date2 = new Date(date);

      let dateFormatter = new Intl.DateTimeFormat("en-US");

      if (date == "Invalid Date") return null;

      let Difference_In_Days = Math.floor((date1 - date2) / (1000 * 60 * 60 * 24));

      return Difference_In_Days;
    },
    sortDate(a, b, key, sortDesc) {
      if (key === "previous_net_price") {
        const aValue = Number(this.getPriceChange(a[key], a.list_price_net).diffPercentage);
        const bValue = Number(this.getPriceChange(b[key], b.list_price_net).diffPercentage);

        if (!isNaN(aValue) && !isNaN(bValue)) {
          return aValue - bValue;
        }
        return this.handleNullSort(isNaN(aValue), isNaN(bValue), sortDesc);
      }

      // 2. Handle "custom_price_confidence" (Enum)
      if (key === "custom_price_confidence") {
        const customOrder = { Verified: 1, Low: 2, Medium: 3, High: 4 };
        const valA = customOrder[a[key]];
        const valB = customOrder[b[key]];

        if (valA !== undefined && valB !== undefined) {
          return valA - valB;
        }
        return this.handleNullSort(valA === undefined, valB === undefined, sortDesc);
      }

      // 3. Handle Dates
      const dateKeys = [
        "sales_start_date", "mls_price_date", "price_date", "rz_sub_date",
        "dp_sub_date", "sold_date", "updated", "occupancy_date", "mls_sold_date"
      ];
      if (dateKeys.includes(key)) {
        const aDate = new Date(a[key]).getTime();
        const bDate = new Date(b[key]).getTime();

        if (!isNaN(aDate) && !isNaN(bDate)) {
          return aDate - bDate;
        }
        return this.handleNullSort(isNaN(aDate), isNaN(bDate), sortDesc);
      }

      // 4. Handle Construction Status (Enum)
      if (["customConstructionStatus", "construction_status"].includes(key)) {
        const customOrder = {
          "": 0, "Pre-Construction": 1, "In Process": 2, "Excavation & Foundation": 3,
          Framing: 4, "Interior Finishing": 5, "Some Homes Complete": 6, Complete: 7
        };
        const valA = customOrder[a[key]];
        const valB = customOrder[b[key]];

        if (valA !== undefined && valB !== undefined) {
          return valA - valB;
        }
        return this.handleNullSort(valA === undefined, valB === undefined, sortDesc);
      }

      // 5. Handle RZ/DP Status (Enum)
      if (["customRz", "customDp", "b"].includes(key)) {
        const customOrder = key === "customRz"
          ? { Adopted: 0, Approved: 1, "Second Reading": 2, "First Reading": 3, "In Process": 4, Submitted: 5, "N/A": 6 }
          : { "Not Submitted": 0, Submitted: 1, "In Process": 2, Approved: 3, Issued: 4, Completed: 5 };

        const valA = customOrder[a[key]];
        const valB = customOrder[b[key]];
        return (valA !== undefined && valB !== undefined) ? valA - valB : -1;
      }

      // 6. Handle Numeric / Currency Strings
      const numericKeys = [
        "custom_net_mls_sold_price", "custom_strata_fee", "custom_parking_stall_cost",
        "custom_storage_locker_cost", "mls_unit_size", "calc_sold_psf", "net_sold_psf",
        "mls_sold_price", "mls_address", "mls_parking", "custom_price_gap", "mls_psf",
        "buyer_incentives", "custom_net_psf", "mls_list_price", "list_price_net",
        "total_net_psf", "custom_total_avg_price", "total_avg_price", "total_avg_psf",
        "custom_mls_net_rent", "custom_sold_psf"
      ];
      if (numericKeys.includes(key)) {
        const parseNum = (val) => typeof val === "number" ? val : Number(String(val).replace(/[$,]/g, ""));
        const aNum = parseNum(a[key]);
        const bNum = parseNum(b[key]);

        if (!isNaN(aNum) && !isNaN(bNum) && aNum > 0 && bNum > 0) {
          return aNum - bNum;
        }
        return this.handleNullSort(isNaN(aNum) || aNum <= 0, isNaN(bNum) || bNum <= 0, sortDesc);
      }

      // 7. Default: String Comparison
      const valA = a[key] || "";
      const valB = b[key] || "";
      const isEmpty = (v) => v === "" || v === "-";

      if (!isEmpty(valA) && !isEmpty(valB)) {
        return valA.toString().localeCompare(valB.toString());
      }
      return this.handleNullSort(isEmpty(valA), isEmpty(valB), sortDesc);
    },
    handleNullSort(isAEmpty, isBEmpty, sortDesc) {
      if (isAEmpty && isBEmpty) return 0;
      if (sortDesc) {
        return isAEmpty ? -1 : 1;
      } else {
        return isAEmpty ? 1 : -1;
      }
    },
    getDefaultValue(data) {
      let result = {
        data: "",
        color: "",
      };

      if (
        (!data.value || data.value.length <= 0) &&
        data.field.key !== "net_psf"
      ) {
        return {
          data: "-",
          color: "",
        };
      }

      const currencyFields = [
        "total_avg_price",
        "mls_list_price",
        "net_price",
        "buyer_incentives",
        "realtor_incentives",
        "total_avg_psf",
        "list_price_net",
        "custom_net_mls_sold_price",
        "custom_net_psf",
        "custom_mls_net_rent",
        "mls_sold_price"
      ];

      if (currencyFields.includes(data.field.key)) {
        if (this.isRealValue(data.value) && parseFloat(data.value) > 0) {
          return {
            data: "$" + Math.round(data.value).toLocaleString(),
            color: this.setColor(data.item.price_back_up),
          };
        }
        return {
          data: "-",
          color: "-",
        };
      }

      if (["psf", "mls_psf", "custom_sold_psf"].includes(data.field.key) && this.isRealValue(data.value)) {
        return {
          data: "$" + (this.isMarketStrata
            ? Math.round(data.value).toLocaleString()
            : Number(data.value).toFixed(2)),
          color: this.setColor(data.item.price_back_up),
        };
      }

      if (data.field.key === "net_psf") {
        const hasValue = !isNaN(data.value) || (data.value && data.value.length > 0);

        if (hasValue) {
          if (
            this.project_status != null &&
            ["now selling", "now leasing"].includes(this.project_status.toLowerCase())
          ) {
            const calculatedValue = Math.round(Number(data.item.net_price) / Number(data.item.mls_unit_size));
            return {
              data: "$" + (isNaN(calculatedValue) ? "0" : calculatedValue.toLocaleString()),
              color: this.setColor(data.item.price_back_up),
            };
          }

          if (this.$route.path === "/unit-mix") {
            if (Number(data.item.net_price) && Number(data.item.mls_unit_size)) {
              return {
                data: "$" + Number(data.item.net_price / data.item.mls_unit_size).toFixed(2),
                color: this.setColor(data.item.price_back_up),
              };
            }
            return {
              data: "-",
              color: "-",
            };
          }
        }

        return {
          data: "-",
          color: "-",
        };
      }

      return {
        data: data.value,
        color: "",
      };
    },
    getFloorPlan(data) { this.$emit("popModal", data); },
    isInCurrentQuarter(date) {
      const now = new Date();
      const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
      const salesDate = new Date(date);
      const salesQuarter = Math.floor(salesDate.getMonth() / 3) + 1;
      return salesDate.getFullYear() === now.getFullYear() && salesQuarter === currentQuarter;
    },
    setConfidenceColor(data) {
      const colors = { high: "#7BB662", medium: "#ffb101", low: "#E03C32" };
      return colors[data?.toLowerCase()] || "#000";
    },
    setColor(data) {
      const colors = { verified: "#0b36dc", "educated estimated": "#dc3545", "semi-verified": "#FF6F16" };
      return colors[data?.toLowerCase()] || "#000";
    },
    onFiltered(filteredItems) { this.model_totalrows = filteredItems.length; },
    onSelectAllRows(payload) {
      // 1. Capture the state (true/false) from the child component's emit
      // Some child components emit a boolean, others emit an object like { selectAll: true }
      const isChecked = typeof payload === 'boolean' ? payload : (payload && payload.selectAll);

      // 2. Sync the local state variable if you are using it elsewhere
      this.all_rows_selected = isChecked;

      // 3. Loop through the currently visible (filtered) data and update rowSelected
      this.model_rowdata.forEach(item => {
        // Use $set to ensure reactivity for the 'rowSelected' property
        this.$set(item, 'rowSelected', isChecked);
      });

      // 4. (Optional) Re-emit to the parent of THIS component if needed
      this.$emit("selectAllRows", {
        selectAll: isChecked,
        tableRef: this.table_reference,
        selectedItems: this.model_rowdata.filter(i => i.rowSelected)
      });
    },
    promptRow(data) { this.$emit("countProjectSelected", data); },
    containsString(obj, searchString) {
      return Object.values(obj).some(val => String(val).toLowerCase().includes(searchString.toLowerCase()));
    },
    filterMlsTable(row, criteria) { /* same logic */ },
    filterProjectTable(row, criteria) { /* same logic */ },
    filterTable(row, criteria) { /* same logic */ },
    getPriceChange(oldValue, newValue) {
      let result = { diffPercentage: "", color: "", icon: "" };
      if (newValue == "-" || !oldValue) return result;
      result.diffPercentage = Number(((newValue - oldValue) / oldValue) * 100).toFixed(2);
      if (Number(result.diffPercentage) > 0) { result.color = "green"; result.icon = "fa-long-arrow-alt-up"; }
      else if (Number(result.diffPercentage) < 0) { result.color = "red"; result.icon = "fa-long-arrow-alt-down"; }
      else { result.color = "black"; result.icon = "minus"; }
      return result;
    },
    addToFilterOptions() {
      const commonConfidence = [
        { id: "status_Verified", label: "Verified", text: "Verified", value: "Verified" },
        { id: "status_Low", label: "Low", text: "Low", value: "Low" },
        { id: "status_Medium", label: "Medium", text: "Medium", value: "Medium" },
        { id: "status_High", label: "High", text: "High", value: "High" },
      ];
      this.custom_filter.priceConfidence.priceConfidence_options = commonConfidence;

      if (this.isMarketStrata) {
        this.custom_filter.listingType.listingType_options = [
          { id: "lt_Presale", label: "Presale", text: "Presale", value: "Presale" },
          { id: "lt_Assignment", label: "Assignment", text: "Assignment", value: "Assignment" },
          { id: "lt_Resale", label: "Resale", text: "Resale", value: "Resale" },
        ];
        this.custom_filter.status.status_options = [
          { id: "status_Active", label: "Active", text: "Active", value: "Active" },
          { id: "status_Leased", label: "Sold", text: "Sold", value: "Sold" },
        ];
      } else {
        this.custom_filter.listingType.listingType_options = [
          { id: "lt_New Lease", label: "New Lease", text: "New Lease", value: "New Lease" },
          { id: "lt_Re-Lease", label: "Re-Lease", text: "Re-Lease", value: "Re-Lease" },
        ];
        this.custom_filter.status.status_options = [
          { id: "status_Active", label: "Active", text: "Active", value: "Active" },
          { id: "status_Sold", label: "Leased", text: "Leased", value: "Leased" },
        ];
      }

      if (this.isAdmin) {
        this.custom_filter.status.status_options.push(
          { id: "status_Unreleased", label: "Unreleased", text: "Unreleased", value: "Unreleased" },
          { id: "status_None", label: "None", text: "None", value: "None" }
        );
      }
    },
    async loadOptions({ action }) {
      let planData = this.row_data.filter(p => this.isRealValue(p.mls_plan_name)).map(item => ({
        id: `plan_${item.mls_plan_name}`,
        label: item.mls_plan_name,
        text: item.mls_plan_name,
        value: item.mls_plan_name,
      }));

      var result = planData.reduce((unique, o) => {
        if (!unique.some(obj => obj.label === o.label)) unique.push(o);
        return unique;
      }, []).sort((a, b) => a.label.localeCompare(b.label));

      if (action === LOAD_ROOT_OPTIONS) {
        await sleep(2000);
        this.custom_filter.planName.planNameOptions = result;
      }
    },
    async saveFilters() {
      const selected_custom_filter = {
        baths: { baths_selected: this.custom_filter.baths.baths_selected },
        beds: { beds_selected: this.custom_filter.beds.beds_selected },
        fpSpecs: { fpSpecs_selected: this.custom_filter.fpSpecs.fpSpecs_selected },
        listingType: { listingType_selected: this.custom_filter.listingType.listingType_selected },
        priceConfidence: { priceConfidence_selected: this.custom_filter.priceConfidence.priceConfidence_selected },
        status: { status_selected: this.custom_filter.status.status_selected },
      };
      try {
        await saveView(this.getViewCategory, "custom_filter", { custom_filter: selected_custom_filter });
        await saveView(this.getViewCategory, "field_selected", { field_selected: this.header_fields });
        await saveView(this.getViewCategory, "custom_headers", { custom_headers: this.custom_headers });
        this.$bvToast.toast(`Filters saved successfully!`, { title: "Great job!", variant: "success", autoHideDelay: 5000 });
      } catch (error) {
        this.$bvToast.toast(`Saving of filters failed.`, { title: "Ooops!", variant: "warning" });
      }
    },
    async loadFilters() {
      const res = await loadView(this.getViewCategory, "custom_filter");
      if (res && typeof res === "object") {
        for (const key in res) {
          if (this.custom_filter[key]) this.custom_filter[key][key + "_selected"] = res[key][key + "_selected"];
        }
      }

      const field_selected = await loadView(this.getViewCategory, "field_selected");
      const custom_headers = await loadView(this.getViewCategory, "custom_headers");

      if (custom_headers && custom_headers !== "[]") {
        var loadedFiltersArray = [...custom_headers, ...field_selected]
        var staticHeaders = [...this.header_fields, ...this.custom_headers]
        var isAllHeaderPresent = loadedFiltersArray.every(loadedHeaders => staticHeaders.some(header => {
          return header.key == loadedHeaders.key
        }))
        if(isAllHeaderPresent && loadedFiltersArray.length == staticHeaders.length)
          this.$emit("updateFields", { header_fields: field_selected, custom_headers: custom_headers });
      }
    },
    rowClass(item) {
      return item.favorite ? "row-highlighted" : "";
    },
    initializeTabulator() {
      const mlsStatusSource = [
        { "text": "None", "value": 11482 },
        { "text": "Active", "value": 8197 },
        { "text": "Sold", "value": 8198 },
        { "text": "Unreleased", "value": 23440 }
      ];

      if (this.$refs.tabulatorTable) {
        this.tabulator = new Tabulator(this.$refs.tabulatorTable, {
          height: "1000px",
          data: this.model_rowdata,
          layout: "fitDataStretch",
          columns: wrapColumns(this.tabulatorColumns),
          reactiveData: false,
          movableRows: true,
          editTriggerEvent: "dblclick",
          popupContainer: "body",
          cellEdited: (cell) => {
            const data = cell.getData();
            this.syncDataChange(data);
          },
          rowFormatter: (row) => {
            const data = row.getData();
            const rawValue = data.custom_status || data.mls_status || "";

            const statusObj = mlsStatusSource.find(s => s.value == rawValue || s.text == rawValue);
            const statusText = (statusObj ? statusObj.text : String(rawValue)).toLowerCase();

            const rowElement = row.getElement();
            const cells = row.getCells();

            let bgColor = "";
            if (statusText === "active") {
              bgColor = "#e8f5e9";
            } else if (statusText === "sold" || statusText === "leased") {
              bgColor = "#ffebee";
            } else if (statusText === "unreleased") {
              bgColor = "#f5f5f5";
            } else {
              bgColor = "#fff";
            }

            if (bgColor) {
              rowElement.style.setProperty('background-color', bgColor, 'important');
              rowElement.style.cursor = "pointer";

              cells.forEach(cell => {
                const cellElement = cell.getElement();
                cellElement.style.setProperty('background-color', bgColor, 'important');
              });
            } else {
              rowElement.style.removeProperty('background-color');
              cells.forEach(cell => cell.getElement().style.removeProperty('background-color'));
            }
          },
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.addToFilterOptions();
      this.loadFilters();
      this.loadOptions({ action: LOAD_ROOT_OPTIONS });

      const path = this.$route.path;
      if (path === "/type") {
        this.pre_sort = this.listing_type === "sold" ? "mls_sold_date" : "mls_price_date";
      } else if (path === "/listing-new") {
        this.pre_sort = "sales_start_date";
      } else {
        this.pre_sort = "price_date";
      }
      this.initializeTabulator();
    });
  },
  beforeDestroy() {
    if (this.tabulator) {
      this.tabulator.destroy();
      this.tabulator = null;
    }
  },
  created() {
    this.tabulator = null;
  },
};
</script>
<style>
.tabulator-cell {
  overflow: visible !important;
}

.tabulator-row:hover,
.tabulator-row.tabulator-editing {
  z-index: 10 !important;
}

.tabulator-datepicker-popup .b-calendar-grid-caption {
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
